import React from 'react';
import { Label } from '../../components/ui/label';
import { Input } from '../../components/ui/input';

// Small helper: renders error message + applies red border className
const errCls = (err) => (err ? 'border-red-500 focus-visible:ring-red-400' : '');
const ErrorMsg = ({ err, field }) =>
  err ? (
    <p className="text-xs text-red-600 mt-1 flex items-start gap-1" data-testid={`error-${field}`}>
      <span aria-hidden>⚠️</span>
      <span>{err}</span>
    </p>
  ) : null;

const PersonalInfoSection = ({ formData, setFormData, countries, fieldErrors = {} }) => (
  <div>
    <h3 className="text-lg font-display font-semibold mb-4 text-tp-text">Informations personnelles</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <Label htmlFor="first_name" className="text-tp-text">Prénom *</Label>
        <Input
          id="first_name"
          required
          value={formData.first_name}
          onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
          placeholder="Votre prénom"
          className={errCls(fieldErrors.first_name)}
          aria-invalid={!!fieldErrors.first_name}
          data-testid="input-first-name"
        />
        <ErrorMsg err={fieldErrors.first_name} field="first_name" />
      </div>
      <div>
        <Label htmlFor="last_name" className="text-tp-text">Nom *</Label>
        <Input
          id="last_name"
          required
          value={formData.last_name}
          onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
          placeholder="Votre nom"
          className={errCls(fieldErrors.last_name)}
          aria-invalid={!!fieldErrors.last_name}
          data-testid="input-last-name"
        />
        <ErrorMsg err={fieldErrors.last_name} field="last_name" />
      </div>
      <div>
        <Label htmlFor="email" className="text-tp-text">Email *</Label>
        <Input
          id="email"
          type="email"
          required
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          placeholder="votre@email.com"
          className={errCls(fieldErrors.email)}
          aria-invalid={!!fieldErrors.email}
          data-testid="input-email"
        />
        <ErrorMsg err={fieldErrors.email} field="email" />
      </div>
      <div>
        <Label htmlFor="phone" className="text-tp-text">Téléphone *</Label>
        <Input
          id="phone"
          type="tel"
          required
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          placeholder="+261 34 00 000 00"
          className={errCls(fieldErrors.phone)}
          aria-invalid={!!fieldErrors.phone}
          data-testid="input-phone"
        />
        <ErrorMsg err={fieldErrors.phone} field="phone" />
      </div>
      <div>
        <Label htmlFor="country" className="text-tp-text">Pays *</Label>
        <select
          id="country"
          required
          value={formData.country}
          onChange={(e) => setFormData({ ...formData, country: e.target.value })}
          className={`flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${fieldErrors.country ? 'border-red-500 focus-visible:ring-red-400' : 'border-input'}`}
          aria-invalid={!!fieldErrors.country}
          data-testid="select-country"
        >
          <option value="">Sélectionnez un pays</option>
          {countries.map(c => (
            <option key={c.code} value={c.code}>{c.name}</option>
          ))}
        </select>
        <ErrorMsg err={fieldErrors.country} field="country" />
      </div>
      <div>
        <Label htmlFor="city" className="text-tp-text">Ville *</Label>
        <Input
          id="city"
          required
          value={formData.city}
          onChange={(e) => setFormData({ ...formData, city: e.target.value })}
          placeholder="Votre ville"
          className={errCls(fieldErrors.city)}
          aria-invalid={!!fieldErrors.city}
          data-testid="input-city"
        />
        <ErrorMsg err={fieldErrors.city} field="city" />
      </div>
    </div>
  </div>
);

export default PersonalInfoSection;
